import API, { Events } from "./api";
import { subscribe } from "./pubsub";

const template = document.createElement("template");
template.innerHTML = `
  <slot id="dynamic" name="loading" />
`;

export const GITHUB_CLIENT_ID = "ENV_GITHUB_CLIENT_ID";

export default class extends HTMLElement {
    #slot

    connectedCallback () {
        this.attachShadow({mode: "open"});
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.#slot = this.shadowRoot.querySelector("slot#dynamic");

        this.#slot.name = API.isLoggedIn ? "logged-in" : "logged-out";

        subscribe(Events.Login, () => this.#slot.name = "logged-in");
        subscribe(Events.Logout, () => this.#slot.name = "logged-out");

        // Defer DOM queries to ensure children are parsed.
        requestAnimationFrame(() => {
            const anchorElements = document.querySelectorAll(".sign_in_with_github");
            const urlParams = new URLSearchParams(window.location.search);
            const isAuthenticating = urlParams.has("code");

            anchorElements.forEach(anchorElement => {
                if (isAuthenticating) {
                    const textSpan = anchorElement.querySelector(".button__text");
                    if (textSpan) {
                        textSpan.textContent = "Signing in…";
                    }
                } else {
                    anchorElement.href = `https://github.com/login/oauth/authorize?scope=user:email&client_id=${GITHUB_CLIENT_ID}`;
                }
            });

            const logoutButton = document.getElementById("logout-button");
            if (logoutButton) {
                logoutButton.addEventListener("click", () => {
                    API.logout();
                    window.location.reload();
                });
            }
        });

        this.classList.add("loaded");
    }
}
